import { createContext, useContext } from 'react';

const BreadcrumbsItemContext = /*#__PURE__*/createContext(null);
const BreadcrumbsItemProvider = BreadcrumbsItemContext.Provider;
const useBreadcrumbsItemContext = () => {
  return useContext(BreadcrumbsItemContext);
};

export { BreadcrumbsItemProvider, useBreadcrumbsItemContext };
